











import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SettingsPage extends Vue {
  // TODO: strongly type settings
  @Prop() private settings!: Record<string, boolean>;
  @Prop() private reset!: Function;

  toggleAutoSave () {
    this.settings.autoSave = !this.settings.autoSave
  }
}
